import { NextResponse } from "next/server";

const experienceData = [
    {
        role: "Product Designer, AtomStore",
        location: "Kraków",
        startYear: "2020",
        endYear: "Obecnie",
        bulletPoints: [
            "Przez ponad 5 lat w strukturach firmy przeszedłem drogę od UX Designera do Product Designera i lidera zespołu UX, który od podstaw stworzyłem.",
            "Wypracowałem procesy UX/UI w organizacji, eliminując potrzebę outsourcingu.",
            "Odpowiadałem za proces wdrozenia WCAG w naszej organizacji - wdrozyliśmy niezbędne poprawki do naszego szablonu oraz przygotowaliśmy proces audytowania ",
            "Obecnie opowiadam za UX/UI dla największych marek w portfolio (projektowałem dla m.in. Ryłko, HalfPrice, Ania Kruk) oraz rozwój naszych produktów.",
            
        ]
    },
    {
       // icon: "/images/icon/asana-icon.svg",
        role: "UX Designer, Stowarzyszenie WIOSNA",
        location: "Kraków",
        startYear: "2018",
        endYear: "2020",
        bulletPoints: [
            "Brałem udział w rozwoju systemów Szlachetnej Paczki oraz Akademii Przyszłości, z której korzysta tysiące wolontariuszy i wolontariuszek.",
            "Przeprowadzałem badania i testy uzyteczności.",
            "Zaprojektowałem system do zarządzania uprawnieniami pracowniczymi w systemach oraz portal do zarządzania wolontariuszami."
        ]
    },
]

const educationData = [
        {
        name: "Kurs Dostępności Cyfrowej, Kinaole",
        startYear: "09.2023",
        endYear: "10.2023",
        bulletPoints: [
            "Przez ponad 5 lat w strukturach firmy przeszedłem drogę od UX Designera do Product Designera i lidera zespołu UX, który od podstaw stworzyłem.",
            "Wypracowałem procesy UX/UI w organizacji, eliminując potrzebę outsourcingu."
            
        ]
    },
            {
        name: "Lepszy Web, Karol Stefański",
        startYear: "09.2023",
        endYear: "10.2023",
        bulletPoints: [
            "Przez ponad 5 lat w strukturach firmy przeszedłem drogę od UX Designera do Product Designera i lidera zespołu UX, który od podstaw stworzyłem.",
            "Wypracowałem procesy UX/UI w organizacji, eliminując potrzebę outsourcingu.",
            
        ]
    },
                  {
        name: "Zwinne zarządzanie - Scrum i Agile, Inprogress ",
        startYear: "09.2023",
        endYear: "10.2023",
        bulletPoints: [
            "Przez ponad 5 lat w strukturach firmy przeszedłem drogę od UX Designera do Product Designera i lidera zespołu UX, który od podstaw stworzyłem.",
            "Wypracowałem procesy UX/UI w organizacji, eliminując potrzebę outsourcingu.",
            
        ]
    },
      {
        name: "Szkoła grafiki komputerowej",
        startYear: "09.2023",
        endYear: "10.2023",
        bulletPoints: [
            "Przez ponad 5 lat w strukturach firmy przeszedłem drogę od UX Designera do Product Designera i lidera zespołu UX, który od podstaw stworzyłem.",
            "Wypracowałem procesy UX/UI w organizacji, eliminując potrzebę outsourcingu.",
            
        ]
    },
      {
        name: "Informatyka Społeczna, AGH",
        startYear: "09.2023",
        endYear: "10.2023",
        bulletPoints: [
            "Przez ponad 5 lat w strukturach firmy przeszedłem drogę od UX Designera do Product Designera i lidera zespołu UX, który od podstaw stworzyłem.",
            "Wypracowałem procesy UX/UI w organizacji, eliminując potrzebę outsourcingu.",
            
        ]
    },
   
];


export const projectOverview = {
    sideProjects: [
        { 
            name: "Kooperatywa Sieciowa", 
            description: "Działam w ramach Kooperatywy Sieciowej realizując wspólnie wiele projektów.", 
            url: "https://koop.net.pl/" 
        },
        { 
            name: "UX Kraków Meetings", 
            description: "Organizuję spotkania dla lokalnej społeczności projektantów UX w Krakowie.", 
            url: "" 
        }
    ]
};

export const elementsOffer = [

        { 
            name: "Projektowanie UX/UI", 
            description: "Tworzę intuicyjne interfejsy, które prowadzą użytkownika prosto do celu, niezależnie od stopnia skomplikowania produktu. Dzięki temu Twoja strona nie tylko wygląda nowocześnie, ale jest przede wszystkim użyteczna i skutecznie realizuje założone cele biznesowe.", 
            
        },
        { 
            name: "Audyt UX", 
            description: "Wskazuję błędy i bariery, które zniechęcają użytkowników do korzystania z Twojego serwisu. Otrzymasz konkretną listę usprawnień, która pozwoli Ci poprawić komfort korzystania ze strony i zwiększyć jej efektywność bez konieczności kosztownego przebudowywania wszystkiego od zera.", 
        
        },
        { 
            name: "Konsultacje i warsztaty", 
            description: "Przekładam cele biznesowe na zrozumiałe procesy projektowe, wspólnie z Twoim zespołem wypracowując optymalne rozwiązania. Pomagam uporządkować wizję produktu, co oszczędza czas na etapie wdrożenia i minimalizuje ryzyko podjęcia nietrafionych decyzji.", 
        
        },
        { 
            name: "Strona wizytówka", 
            description: "Buduję proste, statyczne strony, idealne dla małych firm i przedsiębiorców potrzebujących profesjonalnej obecności w sieci. To wydajne i estetyczne rozwiązanie dla osób, którym zależy na szybkości działania i budowaniu zaufania, bez wdrażania zbędnych, skomplikowanych funkcji.", 
        
        }
    ];


export const collaboratorsData = [
    { 
        name: "Justyna Król", 
        role: "Marketing, copywriting", 
        image: "/images/collaborators/justyna-krol.jpg", 
        socials: {
            linkedin: "https://www.linkedin.com/in/krol-justyna/",
            facebook: "",
            instagram: "",
            email: ""
        }
    },
    { 
        name: "Małgorzata Szymczak", 
        role: "Dostępność Cyfrowa", 
        image: "/images/collaborators/gosia-szymczak.jpeg", 
        socials: {
            linkedin: "https://www.linkedin.com/in/gosia-szymczak/",
            facebook: "",
            instagram: "",
            email: ""
        }
    },
    { 
        name: "Agata Tumidajewicz", 
        role: "Dostępność cyfrowa", 
        image: "/images/collaborators/agata-tumidajewicz.jpg", 
        socials: {
            linkedin: "https://www.linkedin.com/in/agata-tumidajewicz/",
            facebook: "",
            instagram: "",
            email: ""
        }
    },
    { 
        name: "Arkadiusz Sablewski", 
        role: "Front-end, React", 
        image: "/images/collaborators/arkadiusz-sablewski.jpeg", 
        socials: {
            linkedin: "https://www.linkedin.com/in/areksablewski/",
            facebook: "",
            instagram: "",
            www: "https://antonibednarek.pl",
            email: ""
        } 
    },
        { 
        name: "Magdalena Pisula", 
        role: "Badania UX", 
        image: "/images/collaborators/magda-pisula.jpg", 
        socials: {
            linkedin: "https://www.linkedin.com/in/magdalena-pisula-1b4b30196/",
            facebook: "",
            instagram: "",
            email: "mailto:magdalena.pisula@o2.pl"
        }
    },
    { 
        name: "Gabriela Klimczak", 
        role: "Foto, Video", 
        image: "/images/collaborators/gabriela-klimaczak.jpg", 
        socials: {
            linkedin: "",
            facebook: "",
            instagram: "https://www.instagram.com/detailcontent",
            email: ""
        }
    },
    { 
        name: "Antoni Bednarek", 
        role: "Grafika, identyfikacja", 
        image: "/images/collaborators/bednarek.png", 
        socials: {
            linkedin: "",
            facebook: "",
            instagram: "https://www.instagram.com/antonibednarekdesign",
            email: "mailto:antonibednarekdesign@gmail.com"
        } 
    },
    

];
export const contactData = {
    title: "Skontaktuj się ze mną",
    subtitle: "Masz pytanie? Chcesz nawiązać współpracę?",
    methods: [
        {
            icon: "mail", // lub ścieżka do SVG
            label: "Napisz maila",
            value: "bartosz.jawor@protonmail.com",
            href: "mailto:bartosz.jawor@protonmail.com"
        },
        {
            icon: "linkedin",
            label: "Napisz na Linkedin",
            value: "Przejdź do profilu",
            href: "https://linkedin.com/in/twoj-profil"
        }
    ]
};

export const testimonialsData = [
    {
        quote: "Pan Bartosz wykazał się duzym profesjonalizmem, zaangażowaniem i wyczuciem estetyki. Był otwarty na sugestie, reagował szybko na prośby zmian, slużył fachową radą.",
        author: "Dorota Szmigielska",
        role: "psycholożka, coachini",
        companyLogo: "/images/logos/tuple.svg"
    },
    {
        quote: "Bartosz to projektant, który świetnie rozumie cele biznesowe. Jego podejście do e-commerce realnie wpłynęło na naszą konwersję.",
        author: "Justyna Majda-Wardęga",
        role: "Makijazystka",
        companyLogo: "/images/logos/tuple.svg"
    },
    {
        quote: "Współpraca przy projektowaniu systemu dla medycyny była czystą przyjemnością. Bardzo rzetelne podejście do testów z użytkownikami.",
        author: "Anna Nowak",
        role: "Product Manager at HealthCare",
        companyLogo: "/images/logos/reform.svg"
    }
    // Dodaj więcej opinii tutaj...
];


export const GET = async () => {
    return NextResponse.json({
        experienceData,
        educationData,
        projectOverview
    });
    
};
